import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Observable, of } from 'rxjs';
import { RoleAuthConfigResponse } from '../interfaces/user.interface';


@Injectable({
  providedIn: 'root'
})
export class ProgramService {
    private apiUrl = environment.apiUrl;

    constructor(private http: HttpClient) { }

    /**
     * Fetch the allow-list authorization config for a given role + program.
     * Returns the full role config (menus + pages) in a single call.
     */
    fetchRoleAuthorization(programCode: string, roleId: number): Observable<RoleAuthConfigResponse> {
        return this.http.post<RoleAuthConfigResponse>(`${this.apiUrl}/api/v1/getRoleAccessConfig`, {
            programCode,
            roleId
        });
    };
}